import React, { useState, useEffect } from 'react';
import { MenuItem, Select, FormControl, InputLabel, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getAllAssignmentsByIssuerId } from '../../../services/apiservice';
import { useAuth } from '../../../contexts/authContext';
import { useApiData } from '../../../hooks/useApi';
import DataTable from '../../common/DataTable';

function AssignmentList() {
  const theme = useTheme();
  const { user } = useAuth();
  const issuerId = user.IssuerID;
  const { data: fetchedAssignments, loading } = useApiData(() => getAllAssignmentsByIssuerId(issuerId).then((res) => res.data), [issuerId]);
  const [assignments, setAssignments] = useState([]);
  const [statusFilter, setStatusFilter] = useState('All');

  useEffect(() => {
    if (fetchedAssignments) {
      setAssignments(fetchedAssignments);
    }
  }, [fetchedAssignments]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'Assigned':
        return { backgroundColor: theme.palette.warning.main, color: theme.palette.warning.contrastText };
      case 'Active':
        return { backgroundColor: theme.palette.success.main, color: theme.palette.success.contrastText };
      default:
        return { backgroundColor: theme.palette.neutral.main, color: theme.palette.neutral.contrastText };
    }
  };

  const columns = [
    { key: 'AssignmentUserID', label: 'User ID', width: 100 },
    { key: 'AssignmentCredentialID', label: 'Credential ID', width: 150 },
    { key: 'AssignmentDate', label: 'Date', width: 320 },
    {
      key: 'AssignmentStatus',
      label: 'Status',
      width: 200,
      render: (row) => (
        <Chip
          label={row.AssignmentStatus}
          size="small"
          sx={{ backgroundColor: getStatusColor(row.AssignmentStatus).backgroundColor, color: theme.palette.common.white }}
        />
      ),
    },
    {
      key: 'AssignmentIsPublishedOnLinkedIn',
      label: 'Published on LinkedIn',
      width: 250,
      render: (row) => (row.AssignmentIsPublishedOnLinkedIn ? 'Yes' : 'No'),
    },
  ];

  const statusToolbar = (
    <FormControl variant="outlined" size="small" sx={{ minWidth: 120, marginLeft: 2 }}>
      <InputLabel>Status</InputLabel>
      <Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} label="Status">
        <MenuItem value="All">All</MenuItem>
        <MenuItem value="Assigned">Assigned</MenuItem>
        <MenuItem value="Active">Active</MenuItem>
      </Select>
    </FormControl>
  );

  return (
    <DataTable
      title="Assignments List"
      columns={columns}
      rows={assignments}
      loading={loading}
      searchKeys={['AssignmentUserID', 'AssignmentCredentialID', 'AssignmentStatus']}
      rowKey="AssignmentID"
      toolbar={statusToolbar}
      filterFn={(a) => statusFilter === 'All' || statusFilter.toLowerCase() === String(a.AssignmentStatus ?? '').toLowerCase()}
    />
  );
}

export default AssignmentList;
